module.exports = __webpack_public_path__ + "img/video-poster.9c6b9515.jpg";